import React from "react";

import { localizer } from '../../Translator'

import { Grid, Button, Paper } from "@material-ui/core";
import Typography from '@material-ui/core/Typography';

import WorkImage from '../../images/company-realm.jpg';

export class LoginSelectRealm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // List of available reamls for user
      realms: [],
    }
  }

  componentDidMount() { if (this.props.realms) this.setState({ realms: this.props.realms }) }

  render() {
    return (
      <React.Fragment>
        <Grid container direction="row" className="login-realms-container" style={{ display: "block" }}>

          <Typography className="typography-generic medium font-weight-bold">
            {localizer.formatString(localizer.WelcomeSelectRealm, <strong className="color-seconday">{this.props.username}</strong>)}
          </Typography>
          
          {this.state.realms && this.state.realms.map((realm, index) => {
            return (
              <Paper elevation={3} className="login-realm-card mt-10" key={realm.userId + "$$" + realm.realm + "$$" + realm.role}>
                <Grid container direction="row" md={12} className="p-10">
                  <Grid item md={3}>
                    <img src={WorkImage} alt="Work" className="login-realm-card-img" />
                  </Grid>
                  <Grid container item md={6} className="login-realm-card-content">
                    <Typography className="typography-generic ml-10 login-realm-text">
                      <strong className="color-seconday">{realm.realm.toUpperCase()}</strong>
                      <br></br>
                      <br></br>
                      {localizer.LoginInRealmAs}<strong>{realm.role.toUpperCase()}</strong>
                    </Typography>
                  </Grid>
                  <Grid item md={3} className="login-realm-card-actions text-align-center">
                    <Button className="button-generic login login-realm-button"
                      id={realm.userId + "$$" + realm.realm + "$$" + realm.role}
                      variant="contained"
                      color="secondary"
                      onClick={() => this.props.changeSessionRealm(realm)}>
                      {localizer.LoginSelectRealm}
                    </Button>
                  </Grid>
                
                </Grid>
              </Paper>
            )
          })}
        </Grid>
                
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/login/LoginSelectRealm.js